import PLANTILLAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/plantillas/plantillaPorModulo.gql';
import AGREGAR_PLANTILLA from '@/graphql/mutations/administracion/configuracion/plantillas/agregarPlantilla.gql';
import ELIMINAR_PLANTILLA from '@/graphql/mutations/administracion/configuracion/plantillas/removerPlantilla.gql';
import mixDescargarPlantilla from '@/helpers/mixDescargarPlantilla';

export default {
  mixins: [mixDescargarPlantilla],
  methods: {
    async descargarPlantilla(plantillaDescargar) {
      this.mostrarDescargando = plantillaDescargar.id;
      const pathPlantilla = plantillaDescargar.path;
      const nombreArchivo = `${plantillaDescargar.nombre}`;

      await this.mixDescargarPlantilla({
        data: {
          plantilla: pathPlantilla,
        },
      }, nombreArchivo);
      this.mostrarDescargando = null;
    },
    async eliminarPlantilla(plantillaEliminar) {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ELIMINAR_PLANTILLA,
        variables: {
          id: plantillaEliminar.id,
        },
        update: (store) => {
          const query = {
            query: PLANTILLAS_POR_MODULO,
            variables: {
              modulo: this.modulo,
            },
          };
          const { plantillaPorModulo } = store.readQuery(query);
          const index = plantillaPorModulo
            .findIndex(
              (p) => p.id === plantillaEliminar.id,
            );

          if (index !== -1) {
            plantillaPorModulo.splice(index, 1);
          }
          store.writeQuery({
            ...query,
            data: {
              plantillaPorModulo,
            },
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async subirPlantilla() {
      const formData = new FormData();
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      formData.append('anexo', this.archivoAnexo);

      await this.axios
        .post(this.$urlFileServer, formData, options)
        .then(({ data }) => {
          this.plantilla.path = data.data.path;
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });
    },
    async guardar() {
      const { plantilla } = this;
      this.mixEsCargando();
      // Esperar a que suba el archivo
      await this.subirPlantilla();

      // Registrar la nueva plantilla
      await this.$apollo
        .mutate({
          mutation: AGREGAR_PLANTILLA,
          variables: {
            plantilla,
          },
          update: (store, { data: { agregarPlantilla } }) => {
            const data = store.readQuery({
              query: PLANTILLAS_POR_MODULO,
              variables: {
                modulo: this.modulo,
              },
            });

            data.plantillaPorModulo.push(agregarPlantilla);
            store.writeQuery({ query: PLANTILLAS_POR_MODULO, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
    },
  },
};
